<template>
  <div>
    <Drawer title="车队卡详情" width="800" :value="showEdit" :mask-closable="true" @on-close="cancelEdit">
      <Row v-if="cardId>0">
        <Col span="12" class="info-item">
          <span>卡号:</span>
          <span>{{baseInfo.card_no}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>车牌号:</span>
          <span>{{baseInfo.car_number}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>手机号:</span>
          <span>{{baseInfo.user_mobile}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>所属公司:</span>
          <span>{{baseInfo.company_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>额度:</span>
          <span>{{baseInfo.balance}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>创建时间:</span>
          <span>{{baseInfo.create_time}}</span>
        </Col>
      </Row>

      <Card >
          <Form ref="editForm" :label-width="100" :model="formData">
            <FormItem label="所属公司" prop="company_id" v-if="cardId<=0">
              <Select v-model="formData.company_id" :filterable="true" @on-change="getLeaders" >
                <Option v-for="(item,key) in companys" :value="item.company_id" :key="key">{{item.company_name}}</Option>
              </Select>
            </FormItem>

            <FormItem label="车队长" prop="leader_id" v-if="cardId<=0">
              <Select v-model="formData.leader_id">
                <Option v-for="(item,key) in leaders" :value="item.leader_id" :key="key">{{item.leader_name}} {{item.leader_mobile}}</Option>
              </Select>
            </FormItem>
            <FormItem label="车牌号" prop="car_number" v-if="cardId<=0">
              <Input v-model="formData.car_number" placeholder=""></Input>
            </FormItem>
            <FormItem label="是否限额" prop="card_type">
              <Select v-model="formData.card_type">
                <Option value="1">限额</Option>
                <Option value="5">不限额</Option>
              </Select>
            </FormItem>
            <FormItem label="额度" prop="balance" v-if="cardId<=0">
              <Input v-model="formData.balance" placeholder="" maxlength="50"></Input>
            </FormItem>
            <FormItem label="姓名" prop="user_name">
              <Input v-model="formData.user_name" placeholder="" maxlength="50"></Input>
            </FormItem>
            <FormItem label="手机号" prop="user_mobile">
              <Input v-model="formData.user_mobile" placeholder="" maxlength="50"></Input>
            </FormItem>
            <FormItem label="卡密" prop="card_pwd">
              <Input v-model="formData.card_pwd" placeholder="6位数字卡密，开卡必填,编辑可不填" maxlength="6"></Input>
            </FormItem>
          </Form>
        </Card>

        <div class="drawer-footer">
          <Button style="margin-right: 8px" @click="cancelEdit">取消</Button>
          <Button type="primary" @click="doSubmit">确定</Button>
        </div>

    </Drawer>
  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import commonFun from "../../lib/commonFun";
  export default {
    name: "edit",
    components:{pageTable},
    props:{
      showEdit:{
        type:Boolean,
        default: false
      },
      cardId:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        baseInfo:{},
        formData:{
          card_id:0,
          company_id:'',
          balance:'',
          user_name:'',
          user_mobile:'',
          card_pwd:'',
          card_type:'',
          leader_id:'',
        },
        companys:[],
        leaders:[],
            loading: false, // 是否正在加载数据
      }
    },
    methods:{
  
      async getInfo(){
        let res = await this.$commonFun.postProxy('admin/company/getCardInfo',{card_id:this.cardId});
        this.$commonFun.dealApiResult(res,()=>{
          if (this.cardId>0){
            this.formData = res.data.info;
            this.baseInfo = res.data.info;
          }
          this.companys = res.data.companys
        })
      },
      async getLeaders(){
        let res = await this.$commonFun.postProxy('admin/company/getLeadersByCompany',{company_id:this.formData.company_id});
        this.leaders = res.data
      },
      cancelEdit(){
         this.$emit('cancel-edit')
      },
      async doSubmit(){
        let api = this.cardId>0 ? 'admin/company/editCard' : 'admin/company/createCard';
        let res = await this.$commonFun.postProxy(api,this.formData);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.$emit('edit-success')
          })
        })
      }
    },
    mounted() {
        this.getInfo()
    },
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

</style>
